import { render, staticRenderFns } from "./IDPInfomation.vue?vue&type=template&id=2d0942ff"
import script from "./IDPInfomation.vue?vue&type=script&lang=js"
export * from "./IDPInfomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports